import request from '@/utils/request';

/** Setting meta_key: max break minutes per day (global default for AutoCall). */
export const SETTING_AGENT_MAX_DAILY_BREAK = 1;

export interface SettingItem {
  id: number | null;
  meta_key: number;
  meta_value: string;
  label: string;
}

/** Effective break cap for current user (used on AutoCall page). */
export function getBreakCap() {
  return request({
    url: '/settings/break-cap',
    method: 'get',
  });
}

export function getSettings() {
  return request({
    url: '/settings',
    method: 'get',
  });
}

export function updateSetting(metaKey: number, metaValue: string) {
  return request({
    url: `/settings/${metaKey}`,
    method: 'put',
    data: { meta_value: metaValue },
  });
}

// Checkpoint (clock in/out) API
export function getCheckpointStatus() {
  return request({ url: '/checkpoint/status', method: 'get' });
}

export function clockIn() {
  return request({ url: '/checkpoint/clock-in', method: 'post' });
}

export function clockOut() {
  return request({ url: '/checkpoint/clock-out', method: 'post' });
}

// WebSocket auth token (skipAuthRedirect prevents 401 → /login loop)
export function getWsToken() {
  return request({ url: '/ws/auth', method: 'post', skipAuthRedirect: true } as any);
}

// Break log API
export function getBreakStatus() {
  return request({ url: '/break-logs/status', method: 'get' });
}

export function startBreak() {
  return request({ url: '/break-logs/start', method: 'post' });
}

export function endBreak() {
  return request({ url: '/break-logs/end', method: 'post' });
}

export function getTodayBreakLogs(params?: Record<string, any>) {
  return request({ url: '/break-logs/today', method: 'get', params });
}
